import { render } from "./AppUrunler.vue?vue&type=template&id=5516f3d6&scoped=true"
import script from "./AppUrunler.vue?vue&type=script&lang=js"
export * from "./AppUrunler.vue?vue&type=script&lang=js"

import "./AppUrunler.vue?vue&type=style&index=0&id=5516f3d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5516f3d6"]])

export default __exports__